import { Permission, alphabeticalCompare, notEqual } from 'shared'
import { simpleEditNotification } from 'hooks/notificationHandler'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { EditRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import {
  DocumentChecklistItem,
  useDocumentChecklistsTableContext,
} from '../../../../DocumentChecklistsTableContext'
import {
  EditDocumentChecklistItemModalBody,
  EditDocumentChecklistItemModalValues,
} from './components/EditDocumentChecklistItemModalBody'
import { useEditDocumentChecklistItemMutation } from 'schema'

export function useEditOptions(): EditRowActionOptions<
  DocumentChecklistItem,
  EditDocumentChecklistItemModalValues
> {
  const { refetch } = useDocumentChecklistsTableContext()
  const [editItem] = useEditDocumentChecklistItemMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      editDocumentChecklistItem: {
        documentChecklistItem: { name },
      },
    }) => simpleEditNotification(name),
  })
  return {
    permission: Permission.EditDocumentChecklistItem,
    modal: {
      type: 'simple',
      recordName: 'name',
      body: <EditDocumentChecklistItemModalBody />,
      initialValues: ({ name, documentChecklistItemToConcreteMaterials }) => {
        return {
          name,
          placementTypeIds: documentChecklistItemToConcreteMaterials
            .sort((a, b) =>
              alphabeticalCompare(
                a.concreteMaterial?.placementType,
                b.concreteMaterial?.placementType
              )
            )
            .map(({ concreteMaterial }) => concreteMaterial?.globalId),
        }
      },
      onOk: async (
        { id, name: prevName, documentChecklistItemToConcreteMaterials },
        { name, placementTypeIds }
      ) => {
        const prevPlacementTypeIds =
          documentChecklistItemToConcreteMaterials.map(
            ({ concreteMaterial }) => concreteMaterial?.globalId
          )
        if (
          prevName !== name ||
          notEqual(prevPlacementTypeIds, placementTypeIds)
        ) {
          await editItem({
            variables: {
              editDocumentChecklistItemInput: {
                id,
                name,
                concreteMaterialIds: placementTypeIds,
              },
            },
          })
          await refetch()
        }
      },
    },
  }
}
